var React = require('react');

function System3Inline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"q3_icn _healthgoals_energybalance"},React.createElement("g",{"id":"Group"},React.createElement("path",{"id":"Vector","d":"M22.9781 5.01269L8.00805 21.5127C7.98805 21.5427 8.00805 21.5827 8.03805 21.5827H19.0481C19.0681 21.5827 19.0881 21.6027 19.0881 21.6327L16.3981 34.5327C16.3881 34.5727 16.4381 34.5927 16.4681 34.5627L31.3081 17.6627C31.3281 17.6327 31.3081 17.5927 31.2781 17.5927H21.1581C21.1381 17.5927 21.1181 17.5727 21.1181 17.5427L23.048 5.03269C23.048 5.01269 23.0081 4.98269 22.9781 5.01269Z","stroke":"#333333","strokeWidth":"2","strokeMiterlimit":"10"}))));
}

System3Inline.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = System3Inline;

System3Inline.default = System3Inline;
